import RecipeContentMapper from 'services/mappers/recipes/RecipeContentMapper';

const RecipeDataModelFactory = (recipeContent, userModel, hash) => {
  return {
    content: RecipeContentMapper.mapUIModelToDataModel(recipeContent),
    userID: userModel.id,
    hash,
  };
};

export default RecipeDataModelFactory;
